<div class="error confirmation-area">
  <span>{{ title | translate}} </span>
  @if (name) {
    <span>{{'('+ name +')'}}</span>
  }
  @if (body) {
    <span>{{ body }}</span>
  }
  <div class="margin-top-1">
    <button mat-raised-button dianaPreventDoubleClick class="margin-right-1" id="btnConfirmAction" (click)="clickEvent(true)" color="warn">{{'general.label.yes'| translate}}</button>
    <button mat-button (click)="clickEvent(false)" id="btnCancelAction" color="warn">{{'general.label.no' | translate}}</button>
  </div>
</div>